import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionIndustryCardProps extends PropsWithChildren {
  className?: string;
}

export const MotionIndustryCard = ({
  children,
  className,
}: MotionIndustryCardProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.industryCard.amount,
  });

  return (
    <MotionIndustryCardWrapper
      className={className}
      ref={ref}
      initial={{ opacity: 0, scale: ANIMATION_CONFIG.industryCard.scale }}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.industryCard.scale }
      }
      transition={{ duration: ANIMATION_CONFIG.industryCard.duration }}
    >
      {children}
    </MotionIndustryCardWrapper>
  );
};

const MotionIndustryCardWrapper = styled(motion.div)``;
